import { IBudgetItem } from '../../createAndEdit/types';
import { parseDiscountPercent, parseQuantityToNumber } from '../../createAndEdit/utils/budgetCalculations';

interface IDetailServiceItemRowProps {
  item: IBudgetItem;
}

const DetailServiceItemRow = (props: IDetailServiceItemRowProps) => {
  const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    }).format(value);
  };

  const isRemoved = props.item.removed === true;

  return (
    <tr className="border-0 !border-b-0 h-[50px]" style={{ borderBottom: 'none' }}>
      <td className="border-0 !border-b-0" style={{ borderBottom: 'none' }}>
        {props.item.ref}
      </td>
      <td className="border-0 !border-b-0 relative" style={{ borderBottom: 'none' }}>
        {isRemoved && (
          <div className="text-red-400 text-size-14 font-bold px-2 absolute bottom-[-0px] left-0 pl-5 whitespace-nowrap">
            Removido pelo Volks|total
          </div>
        )}
        <div
          className={`text-size-14 ${isRemoved ? '!bg-red-50' : ''}`}
          style={
            isRemoved
              ? { backgroundColor: '#fef2f2', padding: '8px', borderRadius: '4px' }
              : { padding: '8px' }
          }
        >
          {props.item.item}
        </div>
      </td>
      <td className="border-0 !border-b-0" style={{ borderBottom: 'none' }}>
        <div
          className={`text-size-14 ${isRemoved ? '!bg-red-50' : ''}`}
          style={
            isRemoved
              ? { backgroundColor: '#fef2f2', padding: '8px', borderRadius: '4px' }
              : { padding: '8px' }
          }
        >
          {props.item.description}
        </div>
      </td>
      <td className="border-0 !border-b-0 text-right" style={{ borderBottom: 'none' }}>
        <div
          className={`text-size-14 ${isRemoved ? '!bg-red-50' : ''}`}
          style={
            isRemoved
              ? { backgroundColor: '#fef2f2', padding: '8px', borderRadius: '4px' }
              : { padding: '8px' }
          }
        >
          {props.item.quantity}
        </div>
      </td>
      <td className="border-0 !border-b-0 text-right" style={{ borderBottom: 'none' }}>
        <div
          className={`text-size-14 ${isRemoved ? '!bg-red-50' : ''}`}
          style={
            isRemoved
              ? { backgroundColor: '#fef2f2', padding: '8px', borderRadius: '4px' }
              : { padding: '8px' }
          }
        >
          {formatCurrency(props.item.value)}
        </div>
      </td>
      <td className="border-0 !border-b-0 text-right" style={{ borderBottom: 'none' }}>
        <div
          className={`text-size-14 ${isRemoved ? '!bg-red-50' : ''}`}
          style={
            isRemoved
              ? { backgroundColor: '#fef2f2', padding: '8px', borderRadius: '4px' }
              : { padding: '8px' }
          }
        >
          {props.item.discount}
        </div>
      </td>
      <td className="border-0 !border-b-0 text-right" style={{ borderBottom: 'none' }}>
        <div
          className={`text-size-14 ${isRemoved ? '!bg-red-50' : ''}`}
          style={
            isRemoved
              ? { backgroundColor: '#fef2f2', padding: '8px', borderRadius: '4px' }
              : { padding: '8px' }
          }
        >
          {formatCurrency(parseQuantityToNumber(props.item.quantity) * props.item.value * (1 - parseDiscountPercent(props.item.discount) / 100))}
        </div>
      </td>
    </tr>
  );
};

export default DetailServiceItemRow;
